import { render, staticRenderFns } from "./InputFormItem.vue?vue&type=template&id=4bfe47b6&scoped=true&"
import script from "./InputFormItem.vue?vue&type=script&lang=js&"
export * from "./InputFormItem.vue?vue&type=script&lang=js&"
import style0 from "./InputFormItem.vue?vue&type=style&index=0&id=4bfe47b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe47b6",
  null
  
)

export default component.exports